import { useState, useEffect } from 'react';

export function useCountdown(initialSeconds = 86399) {
  const [time, setTime] = useState(initialSeconds);

  useEffect(() => {
    const interval = setInterval(() => setTime(t => (t > 0 ? t - 1 : 0)), 1000);
    return () => clearInterval(interval);
  }, []);

  const h = String(Math.floor(time / 3600)).padStart(2, '0');
  const m = String(Math.floor((time % 3600) / 60)).padStart(2, '0');
  const s = String(time % 60).padStart(2, '0');
  return { h, m, s };
}
